export function getTicketQueueTitle(queue: string): string {
  if (queue === "all") {
    return "Stream";
  }
  return queue.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}
